module.exports = __webpack_public_path__ + "img/unlock.d4281add.svg";